import { useState, useCallback } from 'react';

interface SearchFields {
  title: boolean;
  abstract: boolean;
  keyword: boolean;
  any: boolean;
}

export const useSearchFields = () => {
  const [searchFields, setSearchFields] = useState<SearchFields>({
    title: false,
    abstract: false,
    keyword: false,
    any: true,
  });

  const handleCheckboxChange = useCallback((field: keyof SearchFields) => {
    if (field === 'any') {
      // When "any" is selected, deselect all other fields
      setSearchFields({
        title: false,
        abstract: false,
        keyword: false,
        any: true,
      });
    } else {
      // When any other field is selected, deselect "any"
      setSearchFields((prev) => {
        const newFields = {
          ...prev,
          any: false,
          [field]: !prev[field],
        };

        // If all three are deselected, select "any"
        if (!newFields.title && !newFields.abstract && !newFields.keyword) {
          newFields.any = true;
        }

        return newFields;
      });
    }
  }, []);

  // Function to set search fields from an array (e.g., from URL)
  const setSearchFieldsFromArray = useCallback((fields: string[]) => {
    const newFields: SearchFields = {
      title: fields.includes('title'),
      abstract: fields.includes('abstract'),
      keyword: fields.includes('keyword'),
      any: fields.includes('any') || fields.length === 0,
    };
    setSearchFields(newFields);
  }, []);

  const getPlaceholderText = useCallback(() => {
    return 'What are you looking for?';
  }, []);

  return {
    searchFields,
    handleCheckboxChange,
    setSearchFieldsFromArray,
    getPlaceholderText,
  };
};
